import React, { ReactElement } from 'react'
import Tonno from './games/Tonno'
import Paasinniemi from './games/Paasinniemi'
import Padasjoki from './games/Padasjoki'
import styles from './styles/App.module.css'

function App() {
  const resolveGame = (): ReactElement => {
    console.log(JSON.stringify(process.env))
    switch(process.env.REACT_APP_GAME){
      case 'Tonno': return <Tonno />
      case 'Paasinniemi': return <Paasinniemi />
      case 'Padasjoki': return <Padasjoki />
      default: return <div>Set env variable GAME='Tonno'|'Paasinnemi'|'Padasjoki'</div>
    }
  }

  return (
    <div className={styles.app}>
      {resolveGame()}
    </div>
  )
}

export default App
